var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"authorize"},[_c('div',{staticClass:"authorize-content"},[_c('div',{staticClass:"authorize-img"},[_c('img',{attrs:{"src":"https://chuangpei-prod.oss-cn-hangzhou.aliyuncs.com/images/png_waibushouquan%402x.png"}})]),_c('div',{staticClass:"authorize-text mg-top32"},[_vm._v("该页面使用外部授权，请使用外部授权入口进入观看")])])])
}]

export { render, staticRenderFns }